import AccessibleFakeButton from './AccessibleFakeButton';
import injectInk from '../Inks/injectInk';
export default injectInk(AccessibleFakeButton);